import { callMBankBridge } from 'shared/lib/mbank-bridge'

export const openDeepLink = (uri?: string) => {
  if (!uri) return

  void callMBankBridge('deepLink.open', { url: uri }).then((response) => {
    if (response.ok) return

    window.location.href = uri
  })
}
